import React from 'react'

function TermsOfService() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins lg:m-[100px] mt-5">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Terms of Service</h2>
      <div className="space-y-8 max-w-4xl">

        <h3 className="text-lg font-semibold text-btn-color">1. Acceptance of Terms</h3>
        <p className="text-sm text-white mt-4">
          By accessing or using <span className="text-btn-color-500 font-bold">FinzAid.com</span>, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with these terms, you are prohibited from using or accessing this site.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">2. Use License</h3>
        <p className="text-sm text-white mt-4">
          Permission is granted to temporarily download one copy of the materials (information or software) on <span className="text-btn-color-500 font-bold">FinzAid.com</span>’s website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">3. Disclaimer</h3>
        <p className="text-sm text-white mt-4">
          The materials on <span className="text-btn-color-500 font-bold">FinzAid.com</span>'s website are provided "as is". FinzAid makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">4. Limitations</h3>
        <p className="text-sm text-white mt-4">
          In no event shall <span className="text-btn-color-500 font-bold">FinzAid.com</span> or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on <span className="text-btn-color-500 font-bold">FinzAid.com</span>'s website.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">5. Revisions and Errata</h3>
        <p className="text-sm text-white mt-4">
          The materials appearing on <span className="text-btn-color-500 font-bold">FinzAid.com</span>'s website could include technical, typographical, or photographic errors. FinzAid does not warrant that any of the materials on its website are accurate, complete, or current.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">6. Links</h3>
        <p className="text-sm text-white mt-4">
          <span className="text-btn-color-500 font-bold">FinzAid.com</span> has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by FinzAid.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">7. Ownership of Videos</h3>
        <p className="text-sm text-white mt-4">
          All videos on <span className="text-btn-color-500 font-bold">FinzAid.com</span>, whether recorded by our team or sourced externally and uploaded by us, are owned by <span className="text-btn-color-500 font-bold">FinzAid</span>. These videos cannot be reproduced, distributed, or used in any media without obtaining prior written approval from us. Unauthorized use, distribution, or duplication of these videos is strictly prohibited.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">8. Governing Law</h3>
        <p className="text-sm text-white mt-4">
          These terms and conditions are governed by and construed in accordance with the laws of your jurisdiction and you irrevocably submit to the exclusive jurisdiction of the courts in that jurisdiction.
        </p>

      </div>
    </div>
  )
}

export default TermsOfService;
